import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// Utils
import bemify from 'utils/bemify';

// Utils
import formatPrice from 'utils/format-price';

// Components
import Button from 'components/button';
import RestaurantMenuSidebar from 'components/restaurant-menu/sidebar';
import RestaurantMenuSidebarCartItem from 'components/restaurant-menu/sidebar/cart/item';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const RestaurantMenuCartSidebar = ({
  allergensTranslations = null,
  className = null,
  products = [],
  onCheckout = () => {},
  onClose = () => {},
  onProductUpdate = () => {},
  selectedLocale,
  translations = null
}) => {
  // Computed
  const totalPrice = useMemo(
    () => products.reduce((acc, product) => acc + (product.price * product.quantity), 0),
    [products]
  );

  // Methods
  const handleCheckoutButtonClick = () => {
    onCheckout();
  };

  return (
    <RestaurantMenuSidebar
      className={className}
      translations={translations}
      onClose={onClose}
    >
      <div className={styles.restaurantMenuSidebarCart__content}>
        <h5 className={styles.restaurantMenuSidebarCart__title}>
          {translations.title}
        </h5>
        <ul className={styles.restaurantMenuSidebarCart__products}>
          {Array.isArray(products) && !!products.length ?
            (
              products.map(product => (
                <RestaurantMenuSidebarCartItem
                  key={product.entityId}
                  allergensTranslations={allergensTranslations}
                  product={product}
                  selectedLocale={selectedLocale}
                  onQuantityUpdate={onProductUpdate}
                />
              ))
            ) :
            (
              <li className={styles.restaurantMenuSidebarCart__noProducts}>
                {translations.noProducts}
              </li>
            )}
        </ul>
      </div>
      <footer className={styles.restaurantMenuSidebarCart__footer}>
        <div className={styles.restaurantMenuSidebarCart__totalWrapper}>
          <span className={styles.restaurantMenuSidebarCart__totalLabel}>
            {translations.totalLabel}
            :
          </span>
          <span className={styles.restaurantMenuSidebarCart__price}>
            {formatPrice(totalPrice)}
          </span>
        </div>
        <Button
          className={styles.restaurantMenuSidebarCart__checkoutButton}
          disabled={!products.length}
          text={translations.checkoutButtonLabel}
          onClick={handleCheckoutButtonClick}
        />
      </footer>
    </RestaurantMenuSidebar>
  );
};

RestaurantMenuCartSidebar.propTypes = {
  allergensTranslations: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  onCheckout: PropTypes.func,
  onClose: PropTypes.func,
  onProductUpdate: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.shape({
    allergens: PropTypes.arrayOf(PropTypes.string),
    entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fallbackTranslations: PropTypes.shape({
      title: PropTypes.string
    }),
    imageUrl: PropTypes.string,
    price: PropTypes.number,
    quantity: PropTypes.number,
    title: PropTypes.string,
    translations: PropTypes.shape({
      title: PropTypes.string
    })
  })),
  selectedLocale: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    checkoutButtonLabel: PropTypes.string,
    noProducts: PropTypes.string,
    title: PropTypes.string,
    totalLabel: PropTypes.string
  })
};

export default RestaurantMenuCartSidebar;
